import type { ReactNode } from 'react';

export const symbol_speed_camera: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m698-378-30.57-17.77Q660-400 659-407.97q-1-7.96 6-13.03l91-67q8-5 16.5-6t16.5 4l30.57 17.77Q827-468 828-460t-6 13l-91 67q-8 5-16.5 6t-16.5-4Zm-180-89 130-96-315-178-75 127 260 147Zm-65-137ZM190-160q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h180v-262l-142-80q-22.07-12.96-28.53-36.98Q193-623 206-645l75-125q13-21 36.5-27.5T362-792l355 200q14 8 15.5 24T720-542L553-419q-14 11-31.5 12t-33.5-8l-58-33v228q0 24.75-17.62 42.37Q394.75-160 370-160H190Z"
		/>
	</svg>
);
